const indexedVotingSupportNames = ['AGAINST', 'FOR', 'ABSTAIN'];

export default indexedVotingSupportNames;
